import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

export const useRequiredAuth = () => {
  const roles = useSelector((state) => state.roles);
  const user = useSelector((state) => state.user);

  const userRole = roles.find((role) => role.id === user?.selectedEntity?.role);

  const userPermissions = {};

  userRole?.modules?.forEach((mod) => {
    let tmpPermissions = [];

    if (!!mod.permissions)
      tmpPermissions = [...tmpPermissions, ...mod.permissions];
    else {
      mod.features?.forEach((feature) => {
        if (!!feature.permissions)
          tmpPermissions = [...tmpPermissions, ...feature.permissions];
      });
    }
    tmpPermissions.forEach(({ id }) => {
      userPermissions[id] = true;
    });
  });

  return {
    // isAuth: () => (!isEmpty(user) ? true : false),
    hasPermissions: (permissions) => {
      return !isEmpty(user) && !!permissions.length
        ? permissions.find(
            (permission) =>
              userPermissions[permission] ||
              user?.selectedEntity?.role === "ADMIN"
          )
          ? true
          : false
        : false;
    },
  };
};
